module.exports = __webpack_public_path__ + "img/qrcode.920df61c.jpg";